import React, { Component } from "react"
import PropTypes            from "prop-types"
import { Link }             from "react-router-dom"
import _                    from "lodash"

import swal                                                              from "sweetalert"
import { observer }                                                      from "mobx-react"
import { ButtonGroup, Col, Form, FormField, FormInput, InputGroup, Row } from "elemental-react16"
import { Button, Card, Icon, Input, Segment }                            from "semantic-ui-react"
import shop                                                              from "shop/shop"
import { BreadcrumbsOld }                                                from "components/Breadcrumbs/Breadcrumbs"
import app                                                               from "app.controller"

import ProductTable        from "components/Product/ProductTable"
import Typeahead           from "components/Typeahead/Typeahead"
import CustomProductOption from "components/CustomProductOption/CustomProductOption"
import CSV                 from "components/CSV/CSV"
import Price                 from "components/Price/Price"
import "./OrderlistPage.scss"
import moment                from "moment"
import ProductImporter       from "components/Product/ProductImporter"
import PrintCollectionButton from "components/PrintCollectionButton";
import { slugify }           from "sdk/slugify";

export default class OrderlistPage extends Component {
  state = {
    ok: 1,
    lists: shop.orderlist.lists,
    id: this.props.match.params.id
  }
  
  componentWillReceiveProps( props ) {
    let { id } = props.match.params
    this.setState( {
                     id
                   } )
  }
  
  createList = ( listname, products = false ) => {
    console.log( `creating`, listname )
    let list = shop.orderlist.list( listname )
    products && products.forEach( product => list.add( product ) )
    list.customerTest = shop.session.shopuser.customer
    list.save()
  }
  
  removeList = ( listname ) => {
    shop.orderlist.remove( listname )
  }
  
  componentDidMount() {
    let { orderlist } = shop
    
    window.orderlist = orderlist
    // swal("Erfolg...", "Einstellungen gesichert", "success");
    // swal("Fehler...", "Something went wrong!", "error");
    // swal("Warnung...", "Something went wrong!", "warning");
    shop.orderlist.events.change.add( this.handleLists )
  }
  
  componentWillUnmount() {
    shop.orderlist.events.change.remove( this.handleLists )
  }
  
  handleLists = ( { lists } ) => {
    this.setState( { lists } )
  }
  
  handleChange = ( { product } ) => {
    let list = shop.orderlist.lists[ this.state.id ]
    list.add( product )
    list.save()
    this.setState( { ok: this.state.ok + 1 } )
  }
  
  handleSelect = ( { product } ) => {
    console.log( `selecting`, product )
    let list = shop.orderlist.lists[ this.state.id ]
    list.add( product )
    list.save()
  }
  
  render() {
    let path = [
      { title: translate( "Alle Merklisten" ), link: "/orderlist" }
    ]
    let list = shop.orderlist.lists[ this.state.id ]
    
    let breadTitle = list ? list.customName || list.name : this.state.id
    
    if ( this.state.id ) {
      path.push( {
                   title: breadTitle, link: `/orderlist/${this.state.id}`
                 } )
    }
    console.log("shop.order.list: ",shop.orderlist.lists)
    return (
      <div className="container pb5 pt5">
       {/* <BreadcrumbsOld path={path}/> */}
        {/*LIST MANAGEMENT*/}
        {!this.state.id && <div>
          <h1>{translate( "Orderlist" )}</h1>
          <section>
            <Row>
              <Col sm="1/3">
                <CreateList handleCreate={this.createList}/>
              </Col>
            </Row>
          </section>
          <section className="pb5 bb b--black-10">
            {console.log("shop.orderlist.lists: ",shop.orderlist.lists)}
            <ListsRow
              handleRemove={this.removeList}
              lists={shop.orderlist.lists}/>
          </section>
          
          {<Segment>
            <ProductImporter onSuccess={( products, { name } ) => {
              console.log( "IMPORT", { products } )
              this.createList( name, products )
              return true
            }}/>
          </Segment>}
        </div>
        }
        
        {/*DETAILS FOR A SINGLE LIST*/}
        {(this.state.id && list) && <Row>
          <Col sm="1" md="3/4">
            <section>
              <div className="row-title title--left">
                <h2>{translate( "add" )}</h2>
              </div>
              <Typeahead
                fluid
                optionComponent={CustomProductOption}
                onSelect={this.handleSelect}
                value={this.state.value}
              />
            </section>
          </Col>
          
          {/*          <Col sm="1" md="1/4">
          <div className="row-title title--left">
          <h2> Merkliste (.csv) hochladen </h2>
          </div>
          <CSV onResult={( { products } ) => {
             _.each( products, (product => list.add( product )) )
            }
            }/>
            <p>Hier können Sie Ihre Bestellvorlage hochladen. Nutzen Sie unsere <a
              download={`-Bestellvorlage.csv`}
              href="/Bestellvorlage.csv">{`-Bestellvorlage.csv`}</a>.</p>
          </Col> */}
          
          <section className="padding-bottom db pt4" style={{ width: "100%" }}>
            <Col sm="1">
              <div className="row-title title--left ">
                <div>
                  <div className="flex flex-row justify-center items-center">
                    <div className={"f3 ttu"}><span className="dib mr3">{list.customName || list.title}</span></div>
                    <Button
                      
                      onClick={() => {
                        
                        swal( {
                                title: translate( "Name" ),
                                text: translate( "Merkliste umbennenen" ),
                                type: "input",
                                showCancelButton: true,
                                cancelButtonText: translate( "Cancel" ),
                                closeOnConfirm: false,
                                animation: "slide-from-top",
                                inputPlaceholder: `${list.customName || list.title}`
                              }, ( inputValue ) => {
                          if ( inputValue === false ) return false;
                          if ( inputValue === "" ) {
                            swal.showInputError( translate( "ungültiger Name" ) );
                            return false
                          }
                          
                          
                          list.customName = inputValue
                          list.save()
                          
                          this.props.history.replace( `/orderlist/${list.title}` )
                          swal( list.customName, "List: " + list.customName, "success" );
                        } )
                      }}
                      basic>{translate( "umbenennen" )}</Button>
                  </div>
                </div>
              </div>
              <List list={list} onChange={this.handleChange}/>
              {console.log("list: ",list)}
              <div className="text-right pt3">
              
              </div>
            </Col>
          </section>
          
          <div className="w-100 flex flex-row justify-end">
            {/*{shop.config.usePDFExport && <div className="pr2">*/}
            {/*	<Button onClick={() => {*/}
            {/*	}} basic><Icon name="download" /> {translate( "PDF" )}</Button>*/}
            
            {/*</div>}*/}
            {shop.config.usePDFExport && <div className="pr2">
              <PrintCollectionButton products={Object.values( shop.orderlist.lists[ this.state.id ].products )}/>
            </div>}
            <div className="pr2">
              <Button onClick={() => {
                let list = shop.orderlist.lists[ this.state.id ]
                if ( !list ) return
                shop.cart.export( {
                                    products: Object.values( shop.orderlist.lists[ this.state.id ].products ),
                                    filename: `${this.state.id}-${moment().format( "YYYY-MM-DD--HH-mm" )}`
                                  } )
              }} style={{borderRadius: "25px", width: "200px", height: "60px" }}><Icon name="download"/> {translate( "Exportieren" )}</Button>
            
            </div>
            <Button className=""
                    onClick={
                      () => {
                        shop.orderlist.lists[ this.state.id ] && shop.orderlist.lists[ this.state.id ].listToCart()
                        shop.toast( translate( "toast.LIST_TO_CART" ), "success" )
                        setTimeout( () => {
                          app.sidebar.toggle.dispatch()
                        }, 220 )
                      }
                    }
                    primary> <Icon name="cart"/>{translate( "add all" )}</Button>
          </div>
        
        
        </Row>
        }
      </div>
    )
  }
}


class CreateList extends Component {
  
  state = { name: "" }
  
  handleChange = ( e ) => {
    this.setState( { name: e.target.value } )
  }
  
  render() {
    const { handleCreate } = this.props
    return (
      <Form
        className="pb2"
        onSubmit={( e ) => {
          if ( this.state.name.length >= 3 ) {
            //ehemals slugify
            handleCreate( this.state.name )
          } else {
            shop.toast( translate( "Der Merklisten-Titel sollte mindestens 3 Zeichen beinhalten" ), "warning" )
          }
          e.preventDefault()
        }}>
        <FormField 
                   htmlFor="supported-controls-input">
          <Input
            id="newListName"
            onChange={this.handleChange}
            name="supported-controls-input"
            action={<Button>{translate( "create" )} </Button>} placeholder="name"/>
        </FormField>
      </Form>
    )
  }
}

function cleanID( id ) {
  return id
}

@observer
class ListCard extends Component {
  constructor( props ) {
    super( props )
    let { list } = props
    this.state = {
      list
    }
    list.events.change.add( this.onChange )
  }
  
  onChange = ( { list } ) => {
    console.log( `changed`, list )
    this.setState( list )
  }
  
  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.onChange )
  }
  
  render() {
    let { currentList } = shop.store.orderlist
    let { list, handleRemove } = this.props
    let isDefault = shop.orderlist.default === list
    let isCurrent = currentList === list
    console.log("list: ",list, list.length, list.size, list.sum, this.props)
    console.log("shop.orderlist.default: ", currentList)
    if(list && list.title == "Standard" && currentList == false){
      console.log("Setting current list to Standard")
      shop.store.orderlist.setCurrentList( list )
    }
    /*if(list.customerTest && list.customerTest != shop.session.shopuser.customer){
      console.log("THIS LIST IS A FRAUD", list.title)
      return(<div></div>)
    }*/
    return (
      <Card>
        <Card.Content>
          {/*{isDefault &&  <Button className="mb3" size="sm" type="hollow-success">STANDARD</Button>}*/}
          {/*{!isDefault &&  <Button className="mb3" size="sm" type="hollow-primary">ALS STANDARD</Button>}*/}
          <Link to={`/orderlist/${list.title}`}>
            <h2>{translate( list.customName || list.title )}</h2>
            <div>
              <strong><Price>{list.sum}</Price></strong><br/>
              {list.size > 0 && <span><strong>{list.size}</strong> {translate( "Produkte" )}</span>}
            </div>
          </Link>
        </Card.Content>
        
        <Card.Meta>
          <div className="pa3 text-right bt b--black-10">
            <div className="fl">
              <Button
                style={{  borderRadius: "25px" }}
                title={`Standard`}
                icon={"star"}
                basic={!isCurrent} size="small" primary={isCurrent} onClick={() => {
                if ( isCurrent ) shop.store.orderlist.setCurrentList( false )
                if ( !isCurrent ) shop.store.orderlist.setCurrentList( list )
              }}/>
            </div>
            
            {!isDefault &&
              <Button
                style={{ borderRadius: "25px", backgroundColor: "#ffffff", border: "1px solid #dadada" }}
                size={"small"}
                icon="trash"
                onClick={() => swal( {
                                       title: translate( "Löschen?" ),
                                       text: `"${list.title}"`,
                                       type: "warning",
                                       showCancelButton: true,
                                       animation: false,
                                       confirmButtonText: translate( "Eintrag löschen" ),
                                       cancelButtonText: translate( "Zurück" ),
                                       closeOnConfirm: true,
                                       html: false
                                     }, () => {
                  handleRemove( list.title )
                } )
                }/>
            }
            
            <Button
              size={"small"}
              style={{ backgroundColor: "#a2cf66", color: "white", width: "100px", borderRadius: "25px" }}
              onClick={() => {
              list.listToCart()
              shop.toast( translate( "toast.LIST_TO_CART" ), "success" )
            }}
                    icon="cart"
                    type="primary"/>
          
          
          </div>
        </Card.Meta>
      </Card>
    )
  }
}

ListCard.propTypes = {
  list: PropTypes.object, handleRemove: PropTypes.func
}

@observer
class List extends Component {
  constructor( props ) {
    super( props )
    let { list } = props
    
    this.state = {
      list
    }
    list && list.events.change.add( this.handleListChange )
  }
  
  handleListChange = () => {
    this.forceUpdate()
  }
  
  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.handleListChange )
  }
  
  render() {
    let { list, onChange } = this.props
    return <div className="cf">
      <ProductTable key={list.hash} onChange={onChange} list={list}/>
      {/*<CartTotal list={list}/>*/}
      <br/>
    </div>
  }
}


class ListRows extends Component {
  constructor( props ) {
    super()
    let { list } = props
    this.state = { list }
    list.events.change.add( this.onChange )
  }
  
  onChange = ( { list } ) => {
    console.log( `changed`, list )
    this.setState( list )
  }
  
  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.onChange )
  }
  
  render() {
    let { list, onChange } = this.props
    let products = _.map( list.products, ( product, index ) => {
      return (
        <Row key={index}>
          <Col sm="1/12">
            <img height="34"
                 src={product.img_src_small}
                 alt=""/></Col>
          <Col sm="1/12">{product.article_nr}</Col>
          <Col sm="1/12"><i className="icon icon-circle text-success"/></Col>
          <Col sm="4/12">{product.title}</Col>
          <Col sm="2/12"><Price>{product.price}</Price></Col>
          <Col sm="2/12"
               className="text-right">
            <InputGroup className="margin-0"
                        contiguous>
              <InputGroup.Section>
                <Button onClick={() => {
                  product.count--
                  onChange( { product } )
                }}>-</Button>
              </InputGroup.Section>
              <InputGroup.Section grow>
                <FormInput
                  tabIndex={index}
                  onChange={( e ) => {
                    product.count = Number( e.target.value )
                    onChange( { product } )
                  }}
                  className="text-center"
                  type="number"
                  value={product.count}
                  placeholder="0"/>
              </InputGroup.Section>
              <InputGroup.Section>
                <Button onClick={() => {
                  product.count++
                  onChange( { product } )
                }}>+</Button>
              </InputGroup.Section>
            </InputGroup>
            <ButtonGroup>
              <Button
                onClick={() => {
                  list.remove( product )
                }}
                className="btn-square"
                basic><i className="icon-cancel"/></Button>
              <Button
                onClick={() => {
                  list.toCart( product )
                  shop.toast( translate( "toast.LIST_TO_CART" ), "success" )
                }}
                className="btn-square"
                primary><i className="icon-cart-plus"/></Button>
            </ButtonGroup>
          </Col>
        </Row>
      )
    } )
    return (
      <div className="orderlist-table">
        <Row className="text-bold header">
          <Col sm="1/12"/>
          <Col sm="1/12">{translate( "Artikel-Nr." )}</Col>
          <Col sm="1/12"><i className="icon icon-truck"/></Col>
          <Col sm="4/12">{translate( "Beschreibung" )}</Col>
          <Col sm="2/12">{translate( "Summe" )}</Col>
          <Col sm="2/12" className="text-right">&nbsp;</Col>
        </Row>
        <div className="body">
          {products}
        </div>
      </div>
    )
  }
}

ListRows.propTypes = {
  list: PropTypes.object
}

const ListsRow = ( { lists, handleRemove } ) => {
  console.log("lists: ",lists)
  return <Card.Group
    itemsPerRow={4}
    stackable
  >
    {lists && _.map( lists, ( list, index ) => {
      //if ( list.isArchived === true ) return null
      return <ListCard
        key={index}
        handleRemove={handleRemove}
        list={list}/>
    } )
    }
  </Card.Group>
}
ListsRow.propTypes = {
  lists: PropTypes.object, handleRemove: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/orderlist/OrderlistPage.js